import styled from 'styled-components';

export const $EmptyWeek = styled.div`
  display: flex;
  justify-content: center;
`;
